const identityDatashape = `
  ... on NationalIdType {
      type
      personalPhoto
      idCardNumber
      idCivilRegisterNumber
      idCivilRegisterPlace
      idFrontImage
      idBackImage
  }
      ... on PassportType {
      type
      personalPhoto
      passportNumber
      passportIssueCountry
      passportExpiryDate
      passportAttachment
  }
       
`;
export default identityDatashape;
